/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * logicomix-api
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ChannelVideosSyncStatusApiDTO,
  GetApiVideoPromotionChannelsYoutubeChannelIdPlaylists200,
  GetApiVideoPromotionOperations200,
  GetApiVideoPromotionOperationsOperationId200,
  GetApiVideoPromotionOperationsOperationIdParams,
  GetApiVideoPromotionOperationsParams,
  GetApiVideoPromotionVideos200,
  GetApiVideoPromotionVideosParams,
  GetApiVideoPromotionYoutubeVideosVideoId200,
  GetApiVideoPromotionYoutubeVideosVideoIdParams,
  PostApiVideoPromotionChannelsYoutubeChannelIdSyncVideos200,
  PostApiVideoPromotionChannelsYoutubeChannelIdSyncVideosApiBodies,
  PostApiVideoPromotionOperations200,
  PostApiVideoPromotionOperationsApiBodies,
  PostApiVideoPromotionOperationsOperationIdRetryFailures200
} from './Api.schemas'
import { customInstance } from '../AxiosInstance';
import type { ErrorType } from '../AxiosInstance';




/**
 * Search the synced videos of a channel (sync must have run for the channel)
 */
export const getApiVideoPromotionVideos = (
    params: GetApiVideoPromotionVideosParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiVideoPromotionVideos200>(
      {url: `/api/videoPromotion/videos`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiVideoPromotionVideosQueryKey = (params: GetApiVideoPromotionVideosParams,) => {
    return [`/api/videoPromotion/videos`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiVideoPromotionVideosQueryOptions = <TData = Awaited<ReturnType<typeof getApiVideoPromotionVideos>>, TError = ErrorType<unknown>>(params: GetApiVideoPromotionVideosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionVideos>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiVideoPromotionVideosQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiVideoPromotionVideos>>> = ({ signal }) => getApiVideoPromotionVideos(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionVideos>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiVideoPromotionVideosQueryResult = NonNullable<Awaited<ReturnType<typeof getApiVideoPromotionVideos>>>
export type GetApiVideoPromotionVideosQueryError = ErrorType<unknown>

export const useGetApiVideoPromotionVideos = <TData = Awaited<ReturnType<typeof getApiVideoPromotionVideos>>, TError = ErrorType<unknown>>(
 params: GetApiVideoPromotionVideosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionVideos>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiVideoPromotionVideosQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Playlists of a channel, for the search filter dropdown
 */
export const getApiVideoPromotionChannelsYoutubeChannelIdPlaylists = (
    youtubeChannelId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiVideoPromotionChannelsYoutubeChannelIdPlaylists200>(
      {url: `/api/videoPromotion/channels/${youtubeChannelId}/playlists`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiVideoPromotionChannelsYoutubeChannelIdPlaylistsQueryKey = (youtubeChannelId: string,) => {
    return [`/api/videoPromotion/channels/${youtubeChannelId}/playlists`] as const;
    }

    
export const getGetApiVideoPromotionChannelsYoutubeChannelIdPlaylistsQueryOptions = <TData = Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdPlaylists>>, TError = ErrorType<unknown>>(youtubeChannelId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdPlaylists>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiVideoPromotionChannelsYoutubeChannelIdPlaylistsQueryKey(youtubeChannelId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdPlaylists>>> = ({ signal }) => getApiVideoPromotionChannelsYoutubeChannelIdPlaylists(youtubeChannelId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(youtubeChannelId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdPlaylists>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiVideoPromotionChannelsYoutubeChannelIdPlaylistsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdPlaylists>>>
export type GetApiVideoPromotionChannelsYoutubeChannelIdPlaylistsQueryError = ErrorType<unknown>

export const useGetApiVideoPromotionChannelsYoutubeChannelIdPlaylists = <TData = Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdPlaylists>>, TError = ErrorType<unknown>>(
 youtubeChannelId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdPlaylists>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiVideoPromotionChannelsYoutubeChannelIdPlaylistsQueryOptions(youtubeChannelId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Any YouTube video by id, synced or not and from any channel, to target it from an endscreen element or an
infocard. youtubeChannelId is the channel of the operation, whose content owner makes the call.
 */
export const getApiVideoPromotionYoutubeVideosVideoId = (
    videoId: string,
    params: GetApiVideoPromotionYoutubeVideosVideoIdParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiVideoPromotionYoutubeVideosVideoId200>(
      {url: `/api/videoPromotion/youtubeVideos/${videoId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiVideoPromotionYoutubeVideosVideoIdQueryKey = (videoId: string,
    params: GetApiVideoPromotionYoutubeVideosVideoIdParams,) => {
    return [`/api/videoPromotion/youtubeVideos/${videoId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiVideoPromotionYoutubeVideosVideoIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiVideoPromotionYoutubeVideosVideoId>>, TError = ErrorType<unknown>>(videoId: string,
    params: GetApiVideoPromotionYoutubeVideosVideoIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionYoutubeVideosVideoId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiVideoPromotionYoutubeVideosVideoIdQueryKey(videoId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiVideoPromotionYoutubeVideosVideoId>>> = ({ signal }) => getApiVideoPromotionYoutubeVideosVideoId(videoId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(videoId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionYoutubeVideosVideoId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiVideoPromotionYoutubeVideosVideoIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiVideoPromotionYoutubeVideosVideoId>>>
export type GetApiVideoPromotionYoutubeVideosVideoIdQueryError = ErrorType<unknown>

export const useGetApiVideoPromotionYoutubeVideosVideoId = <TData = Awaited<ReturnType<typeof getApiVideoPromotionYoutubeVideosVideoId>>, TError = ErrorType<unknown>>(
 videoId: string,
    params: GetApiVideoPromotionYoutubeVideosVideoIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionYoutubeVideosVideoId>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiVideoPromotionYoutubeVideosVideoIdQueryOptions(videoId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Manually trigger the videos sync of a channel, limited to its most recent videos unless fullResync is set.
includeUnlisted also searches non-public videos: quota heavy, the front must ask confirmation first.
 */
export const postApiVideoPromotionChannelsYoutubeChannelIdSyncVideos = (
    youtubeChannelId: string,
    postApiVideoPromotionChannelsYoutubeChannelIdSyncVideosApiBodies: PostApiVideoPromotionChannelsYoutubeChannelIdSyncVideosApiBodies,
 ) => {
      
      
      return customInstance<PostApiVideoPromotionChannelsYoutubeChannelIdSyncVideos200>(
      {url: `/api/videoPromotion/channels/${youtubeChannelId}/syncVideos`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiVideoPromotionChannelsYoutubeChannelIdSyncVideosApiBodies
    },
      );
    }
  


export const getPostApiVideoPromotionChannelsYoutubeChannelIdSyncVideosMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiVideoPromotionChannelsYoutubeChannelIdSyncVideos>>, TError,{youtubeChannelId: string;data: PostApiVideoPromotionChannelsYoutubeChannelIdSyncVideosApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiVideoPromotionChannelsYoutubeChannelIdSyncVideos>>, TError,{youtubeChannelId: string;data: PostApiVideoPromotionChannelsYoutubeChannelIdSyncVideosApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiVideoPromotionChannelsYoutubeChannelIdSyncVideos>>, {youtubeChannelId: string;data: PostApiVideoPromotionChannelsYoutubeChannelIdSyncVideosApiBodies}> = (props) => {
          const {youtubeChannelId,data} = props ?? {};

          return  postApiVideoPromotionChannelsYoutubeChannelIdSyncVideos(youtubeChannelId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiVideoPromotionChannelsYoutubeChannelIdSyncVideosMutationResult = NonNullable<Awaited<ReturnType<typeof postApiVideoPromotionChannelsYoutubeChannelIdSyncVideos>>>
    export type PostApiVideoPromotionChannelsYoutubeChannelIdSyncVideosMutationBody = PostApiVideoPromotionChannelsYoutubeChannelIdSyncVideosApiBodies
    export type PostApiVideoPromotionChannelsYoutubeChannelIdSyncVideosMutationError = ErrorType<unknown>

    export const usePostApiVideoPromotionChannelsYoutubeChannelIdSyncVideos = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiVideoPromotionChannelsYoutubeChannelIdSyncVideos>>, TError,{youtubeChannelId: string;data: PostApiVideoPromotionChannelsYoutubeChannelIdSyncVideosApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiVideoPromotionChannelsYoutubeChannelIdSyncVideos>>,
        TError,
        {youtubeChannelId: string;data: PostApiVideoPromotionChannelsYoutubeChannelIdSyncVideosApiBodies},
        TContext
      > => {

      const mutationOptions = getPostApiVideoPromotionChannelsYoutubeChannelIdSyncVideosMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Status of a sync started by syncChannelVideos, polled by the front until it is no longer pending. A cancelled job is reported as failed.
 */
export const getApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobId = (
    youtubeChannelId: string,
    jobId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ChannelVideosSyncStatusApiDTO>(
      {url: `/api/videoPromotion/channels/${youtubeChannelId}/syncVideos/${jobId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobIdQueryKey = (youtubeChannelId: string,
    jobId: string,) => {
    return [`/api/videoPromotion/channels/${youtubeChannelId}/syncVideos/${jobId}`] as const;
    }

    
export const getGetApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobId>>, TError = ErrorType<unknown>>(youtubeChannelId: string,
    jobId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobIdQueryKey(youtubeChannelId,jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobId>>> = ({ signal }) => getApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobId(youtubeChannelId,jobId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(youtubeChannelId && jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobId>>>
export type GetApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobIdQueryError = ErrorType<unknown>

export const useGetApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobId = <TData = Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobId>>, TError = ErrorType<unknown>>(
 youtubeChannelId: string,
    jobId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobId>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiVideoPromotionChannelsYoutubeChannelIdSyncVideosJobIdQueryOptions(youtubeChannelId,jobId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiVideoPromotionOperations = (
    postApiVideoPromotionOperationsApiBodies: PostApiVideoPromotionOperationsApiBodies,
 ) => {
      
      
      return customInstance<PostApiVideoPromotionOperations200>(
      {url: `/api/videoPromotion/operations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiVideoPromotionOperationsApiBodies
    },
      );
    }
  


export const getPostApiVideoPromotionOperationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiVideoPromotionOperations>>, TError,{data: PostApiVideoPromotionOperationsApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiVideoPromotionOperations>>, TError,{data: PostApiVideoPromotionOperationsApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiVideoPromotionOperations>>, {data: PostApiVideoPromotionOperationsApiBodies}> = (props) => {
          const {data} = props ?? {};

          return  postApiVideoPromotionOperations(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiVideoPromotionOperationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiVideoPromotionOperations>>>
    export type PostApiVideoPromotionOperationsMutationBody = PostApiVideoPromotionOperationsApiBodies
    export type PostApiVideoPromotionOperationsMutationError = ErrorType<unknown>

    export const usePostApiVideoPromotionOperations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiVideoPromotionOperations>>, TError,{data: PostApiVideoPromotionOperationsApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiVideoPromotionOperations>>,
        TError,
        {data: PostApiVideoPromotionOperationsApiBodies},
        TContext
      > => {

      const mutationOptions = getPostApiVideoPromotionOperationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiVideoPromotionOperations = (
    params?: GetApiVideoPromotionOperationsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiVideoPromotionOperations200>(
      {url: `/api/videoPromotion/operations`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiVideoPromotionOperationsQueryKey = (params?: GetApiVideoPromotionOperationsParams,) => {
    return [`/api/videoPromotion/operations`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiVideoPromotionOperationsQueryOptions = <TData = Awaited<ReturnType<typeof getApiVideoPromotionOperations>>, TError = ErrorType<unknown>>(params?: GetApiVideoPromotionOperationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionOperations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiVideoPromotionOperationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiVideoPromotionOperations>>> = ({ signal }) => getApiVideoPromotionOperations(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionOperations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiVideoPromotionOperationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiVideoPromotionOperations>>>
export type GetApiVideoPromotionOperationsQueryError = ErrorType<unknown>

export const useGetApiVideoPromotionOperations = <TData = Awaited<ReturnType<typeof getApiVideoPromotionOperations>>, TError = ErrorType<unknown>>(
 params?: GetApiVideoPromotionOperationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionOperations>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiVideoPromotionOperationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiVideoPromotionOperationsOperationId = (
    operationId: string,
    params?: GetApiVideoPromotionOperationsOperationIdParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiVideoPromotionOperationsOperationId200>(
      {url: `/api/videoPromotion/operations/${operationId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiVideoPromotionOperationsOperationIdQueryKey = (operationId: string,
    params?: GetApiVideoPromotionOperationsOperationIdParams,) => {
    return [`/api/videoPromotion/operations/${operationId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiVideoPromotionOperationsOperationIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiVideoPromotionOperationsOperationId>>, TError = ErrorType<unknown>>(operationId: string,
    params?: GetApiVideoPromotionOperationsOperationIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionOperationsOperationId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiVideoPromotionOperationsOperationIdQueryKey(operationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiVideoPromotionOperationsOperationId>>> = ({ signal }) => getApiVideoPromotionOperationsOperationId(operationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(operationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionOperationsOperationId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiVideoPromotionOperationsOperationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiVideoPromotionOperationsOperationId>>>
export type GetApiVideoPromotionOperationsOperationIdQueryError = ErrorType<unknown>

export const useGetApiVideoPromotionOperationsOperationId = <TData = Awaited<ReturnType<typeof getApiVideoPromotionOperationsOperationId>>, TError = ErrorType<unknown>>(
 operationId: string,
    params?: GetApiVideoPromotionOperationsOperationIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiVideoPromotionOperationsOperationId>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiVideoPromotionOperationsOperationIdQueryOptions(operationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Re-enqueue the failed videos of a finished operation
 */
export const postApiVideoPromotionOperationsOperationIdRetryFailures = (
    operationId: string,
 ) => {
      
      
      return customInstance<PostApiVideoPromotionOperationsOperationIdRetryFailures200>(
      {url: `/api/videoPromotion/operations/${operationId}/retryFailures`, method: 'POST'
    },
      );
    }
  


export const getPostApiVideoPromotionOperationsOperationIdRetryFailuresMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiVideoPromotionOperationsOperationIdRetryFailures>>, TError,{operationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiVideoPromotionOperationsOperationIdRetryFailures>>, TError,{operationId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiVideoPromotionOperationsOperationIdRetryFailures>>, {operationId: string}> = (props) => {
          const {operationId} = props ?? {};

          return  postApiVideoPromotionOperationsOperationIdRetryFailures(operationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiVideoPromotionOperationsOperationIdRetryFailuresMutationResult = NonNullable<Awaited<ReturnType<typeof postApiVideoPromotionOperationsOperationIdRetryFailures>>>
    
    export type PostApiVideoPromotionOperationsOperationIdRetryFailuresMutationError = ErrorType<unknown>

    export const usePostApiVideoPromotionOperationsOperationIdRetryFailures = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiVideoPromotionOperationsOperationIdRetryFailures>>, TError,{operationId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiVideoPromotionOperationsOperationIdRetryFailures>>,
        TError,
        {operationId: string},
        TContext
      > => {

      const mutationOptions = getPostApiVideoPromotionOperationsOperationIdRetryFailuresMutationOptions(options);

      return useMutation(mutationOptions);
    }
    